// The site's day is a UK day (CLAUDE.md: Rollover timezone is explicit).
//
// Never the device's timezone: a player abroad sees the same puzzle as one at
// home, and the countdown to the next puzzle is measured against the same clock.
//
// No date is ever shown to a player — a puzzle is identified by its number — so
// the only thing this file formats is the time left until the next daily. The
// date a daily publishes on is a stored field that decides which puzzle today
// is, and it stays on the server.
const ZONE = 'Europe/London';

// Which day it is in Britain, as YYYY-MM-DD. Nothing displays it; it is here
// because the data layer will ask "which puzzle is today's" and the answer has
// to come from this clock, not the device's.
export function ukToday(now: Date = new Date()): string {
  // en-CA gives YYYY-MM-DD, which sorts and compares.
  return new Intl.DateTimeFormat('en-CA', { timeZone: ZONE }).format(now);
}

// Time left until the next UK midnight, for the "Next Running Order in" line.
export function untilNextUkMidnight(now: Date = new Date()): { hours: number; minutes: number; seconds: number } {
  const parts = new Intl.DateTimeFormat('en-GB', {
    timeZone: ZONE, hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
  }).formatToParts(now);
  const get = (type: string) => Number(parts.find((p) => p.type === type)?.value ?? 0);
  const secondsIntoDay = get('hour') * 3600 + get('minute') * 60 + get('second');
  const left = 86_400 - secondsIntoDay;
  return {
    hours: Math.floor(left / 3600),
    minutes: Math.floor((left % 3600) / 60),
    seconds: left % 60
  };
}
